import { useEffect, useRef } from 'react';
import { useScript } from 'usehooks-ts';

import type { AdSelectionProps } from './types.ts';

import { useEnvironmentConfig } from '#src/hooks/environment.tsx';
import { useQueryParam } from '#src/hooks/queryParams.ts';

export const AdSelectionLoader = ({ props }: { props: AdSelectionProps }) => {
  const {
    baseUrls: { panels },
  } = useEnvironmentConfig();

  const [panelVersion] = useQueryParam('v-panel');
  const version = panelVersion ? `/${panelVersion}` : '';

  const status = useScript(`${panels}${version}/SeekApi.js`);

  const node = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (window.SeekApi && node?.current) {
      window.SeekApi.render(node.current, 'adSelection', props);
    }
  }, [status, props]);

  if (
    status === 'error' ||
    (status === 'ready' && typeof window.SeekApi === 'undefined')
  ) {
    return null;
  }

  return <div ref={node} />;
};
